import { Checkbox, Group, NumberInput, Text } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { useTranslation } from 'react-i18next';
import { RuleTimeFrames } from 'models/rules';
import { displayFormError } from 'utils/validation';
import { AccordionWithSwitch } from './AccordionWithSwitch';
import { TimeWindowField } from '../TimeWindowField';

export const NumberOfDaysFields = () => {
  const { t } = useTranslation();
  const { getInputProps, values, errors } = useCreateRuleFormContext();

  const dataField = 'data.heartRhythmMeasurement.numberOfDaysCondition';
  const numberOfMeasurementsEnabled = values.data.heartRhythmMeasurement.numberOfMeasurementsCondition.enabled;

  return (
    <AccordionWithSwitch
      title={`${t('number_of_days_label')} *`}
      dataField={dataField}
      disabled={numberOfMeasurementsEnabled}
    >
      <Text size={'xs'} mb={-5} c={'var(--mantine-color-blue-5)'}>
        {t('number_of_days_description')}
      </Text>
      <Group gap={'xl'} align={'flex-start'}>
        <NumberInput
          label={t('count_label')}
          {...getInputProps(`${dataField}.numberOfDays.amount`)}
          allowNegative={false}
          allowDecimal={false}
          min={1}
          max={1000}
          disabled={values.formDisabled}
          clampBehavior={'strict'}
          error={displayFormError({ errors, dataField: `${dataField}.numberOfDays.amount` })}
        />
        <TimeWindowField dataField={`${dataField}.numberOfDays.timeWindow`} allowedFrames={[RuleTimeFrames.days]} />
      </Group>
      <Checkbox
        label={t('require_consecutive_days_label')}
        {...getInputProps(`${dataField}.numberOfDays.isConsecutive`, {
          type: 'checkbox',
        })}
        disabled={values.formDisabled}
      />
    </AccordionWithSwitch>
  );
};
